var Codec = require('io/codec');
var ErrorReportSerialiser = require('../error-report-serialiser');

var SecurityCommandScriptResult = require('./security-command-script-result');

var serialiser = {
    read : function(input) {
        var errors = Codec.readCollection(input, ErrorReportSerialiser.read);
        return new SecurityCommandScriptResult(errors);
    },
    write : function(output, value) {
        Codec.writeCollection(output, value.errors, ErrorReportSerialiser.write);
    }
};

module.exports = serialiser;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/authentication/security-command-script-result-serialiser.js
// module id = 1001
// module chunks = 1